import CapacityGasDraftDTO from 'features/contracts/dtos/CapacityGasDraftDTO';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CapacityTypeLabel from './CapacityTypeLabel';

type Props = {
  capacity: CapacityGasDraftDTO;
}

const CapacityGasDraft = ({ capacity }: Props) => {
  // translations
  const { t } = useTranslation(["contracts\\enums\\capacityGasType"]);
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col-sm-5 col-lg-4">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("capacityGasDraft.timePeriod")}
          </div>
          <div>
            <DateFormatter date={capacity.from!} /> - <DateFormatter date={capacity.to!} />
          </div>
        </div>
      </div>
      <div className="col-sm-3 col-lg-4 text-sm-center">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("capacityGasDraft.capacity")}
          </div>
          <div>
            <NumberFormatter amount={capacity.capacity!} />
            <span className="d-sm-none small"> m<sup>3</sup></span>
          </div>
        </div>
      </div>
      <div className="col-sm-2 text-sm-center">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("capacityGasDraft.type")}
          </div>
          <div>
            {t(capacity.capacityType!)}
          </div>
        </div>
      </div>
      <div className="col-sm-2 text-sm-right">
        <div className="d-flex d-sm-block justify-content-between">
          <div className="d-sm-none text-muted pr-2">
            {tLabels("capacityGasDraft.state")}
          </div>
          <div>
            <CapacityTypeLabel type={capacity.type!} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CapacityGasDraft;